import { NgModule } from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import { AuthGuard } from './auth.guard';
import { DashboardModule } from './dashboard/dashboard.module';

import { LoginComponent } from './login/login/login.component';

 export function loadComponent() {
  return DashboardModule;
} 

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  // { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'dashboard', loadChildren: './dashboard/dashboard.module#DashboardModule', canActivate: [AuthGuard]}, 
  { path: 'login',  component: LoginComponent}
];
	

@NgModule({
  imports: [
    RouterModule.forRoot(routes
      // ,{enableTracing: true}
      ) 
  ],
  exports: [
  	RouterModule
  ]
})
export class AppRoutingModule { }




// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/app-routing.module.ts